module.exports = __webpack_public_path__ + "img/prestige-coupon-inactive@3x-en.png";